<template>
    <div class="card card-body">
        <form @submit.prevent="storeData">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <td><button type="button" class="btn bg-gradient-success mb-0" @click="addRow">Tambah</button></td>
                            <td v-for="dataHeader in this.formBuilder" v-bind:key="dataHeader">{{ dataHeader.name }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in this.data" v-bind:key="row">
                            <td><button type="button" class="btn bg-gradient-danger mb-0" @click="removeRow(index)" v-if="index != 0">Hapus</button></td>
                            <td v-for="dataBody in this.formBuilder" v-bind:key="dataBody">
                                <input :type="dataBody.var.includes('tgl') ? 'date' : 'text'" class="form-control" v-model="this.data[index][dataBody.var]" @change="localstorageSet">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-end">
                <button class="btn bg-gradient-success">Simpan</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "UserPengujianForm",
    data() {
        return {
            id: this.$route.params.id,
            user_id: window.localStorage.getItem('user_id'),
            data: [],
            formBuilder: {}
        }
    },
    methods: {
        localstorageSet() {
            localStorage.setItem('hasilUji_' + this.id, JSON.stringify(this.data));
        },
        addRow() {
            this.data.push({});
        },
        removeRow(index) {
            this.data.splice(index, 1);
        },
        storeData() {
            this.axios.post('operator/hasiluji', { usulan_id: this.id, hasil_uji: this.data, user_id: this.user_id }).then((response) => {
                this.axios.post('update-status-usulan', { usulan_id: this.id, message: 'Proses Analisis Data' }).then(() => {
                    this.$swal.fire({ icon: 'success', title: response.data.message }).then(() => {
                        this.$router.push({ name: 'ujilab.pengujian' });
                    });
                });
            });
        }
    },
    mounted() {
        this.axios.get('usulan/' + this.id).then((response) => {
            this.formBuilder = JSON.parse(response.data.data.r_sub_kategori.proses);
            try {
                this.data = JSON.parse(window.localStorage.getItem('hasilUji_' + this.id));
                if (this.data == null) {
                    this.data = [{}];
                }
            } catch (error) {
                this.addRow();
            }
            // this.$router.push({ name: 'ujilab.pengujian.form-upload', params: { id: response.data.data.id } });
        });
    }
}
</script>